import { render } from "./Loading.vue?vue&type=template&id=ffa58c1c"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Loading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ffa58c1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ffa58c1c', __exports__)) {
    api.reload('ffa58c1c', __exports__)
  }
  
  module.hot.accept("./Loading.vue?vue&type=template&id=ffa58c1c", () => {
    api.rerender('ffa58c1c', render)
  })

}


export default __exports__